import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { connectHits } from "react-instantsearch-core";
import axios from "axios";
import { useLocation } from "@reach/router"
import { Link } from "gatsby";
import PropertyCard from "./PropertyCard/PropertyCard";
// import SearchList from "./SearchList/SearchList";

const NoResultsPage = (props) => {
    const [propItems, setPropItems] = useState([]);
    const location = useLocation();
    useEffect(() => {
        // featured properties
        let sale = location.pathname.includes("for-sale")
        let url = process.env.GATSBY_STRAPI_SRC + `/stb-lists/item/featured${sale?"-sales":"-lettings"}/`;
        if(props.hits.length === 0) {
            getItems(url);
        }
    }, [props.hits]);

    const getItems = async url => {
        try {
            const { data } = await axios.get(url, {})
            if (data && data.length > 0) {
                setPropItems(data)
            }
        } catch (error) {
            console.error(error)
        }
    }
    return (
            <Container>
                {props.hits.length === 0 && 
                    <div className="no-results-page my-xl-5 pb-xl-4 my-lg-4 my-md-3 pb-md-3 my-0 pb-0">
                        <div className="row h-100 align-items-center">
                            <div className="col-md-12">
                                <h5 className="text-center my-3"><b>Unfortunately, we do not currently have any properties that match your search criteria.</b></h5>
                            </div>
                            <div className="col-md-12 mt-0">
                                <h5 className="text-center results-page-wrapper"><b>Please</b> <Link to="/contact/" className="tlc-link">contact us</Link></h5>
                                <Row className="mt-5 property-list">
                                    {propItems.map((property, i) => 
                                        <Col md={6} xl={4} xs={12} key={property.id}>
                                            <PropertyCard
                                                key={property.id} 
                                                searchResults={false}
                                                propertyList={{
                                                    propertyImg: property.images[0]?.large_url ? property.images[0]?.large_url : property.images[0]?.url,
                                                    propertyTitle: property.intro,
                                                    propertyPrice: `£ ${property.price.toLocaleString()}`,
                                                    propertyInfo: property.title,
                                                    propertyRoom: property.bedroom,
                                                    propertyBathroom: property.bathroom,
                                                    propertyReception: property.reception,
                                                    propertyDesc: property.description,
                                                    offerTag: property.status?.toLowerCase() === "under offer",
                                                    propertyStatus: property.search_type === "sales",
                                                    offerText: "Under Offer",
                                                    callInfo:'00000000',
                                                    propertyLink: `/property-${(property?.searchType === "sales" || property?.search_type === "sales") ? "for-sale" : "to-rent"}/${property.slug}-${property.id}/`
                                                }}
                                            />
                                        </Col>
                                    )}
                                </Row>
                                {/* <div className="mt-5 pt-4">
                                    <SearchList
                                        hits={propItems}
                                        strapi={true}
                                    /> 
                                </div>*/}
                            </div>
                        </div>
                    </div>
                }
            </Container>
    )
};
export default connectHits(NoResultsPage)
